<template>
    <div id="planning_urusan" >

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Laporan Evaluasi Kinerja</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button  @click="Printing"  type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" ><i class="material-icons">print</i></button>
                            </span>
                            <select  class="form-control" >
                                <option value="2019">2019</option>
                            </select>
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card" id="printMe">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>

                <table  style="width: 100% !important">
                 <tr>
                    <td style="width: 10%" class="text-right">
                        <img src="images/logo konsel.png" alt="" width="50">
                    </td>
                    <td style="width: 90% !important" class="text-center h_kop_1">
                        <b class="text-center">
                            <span>PEMERINTAH DAERAH KABUPATEN KONAWE SELATAN</span> <br>
                            <span>LAPORAN EVALUASI KINERJA TAHUN {{data.tahun}}</span>
                        </b>
                    </td >
                    <td style="width: 10% !important"></td>
                </tr>

                </table>
                
                <hr>
                <br>



                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 55%">Unit Kerja</th>
                            <th class="text-center" style="width: 20%">Nilai</th>
                            <th class="text-center" style="width: 20%">Kategori</th>

                        </tr>
                       
                        </thead>
                        <tbody>
                            <!-- track-by="data.createdtime" -->
                            <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.unit_kerja">
                                <td class="text-center">{{index+1}}</td>
                                <td >{{data.unit_kerja_uraian}}</td>
                                <td class="text-center">{{data.nilai}}</td>
                                <td class="text-center">
                                    <div v-html="checkKategori(data.nilai)"></div>

                                </td>
                               
                            </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-md" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">

                                <div class="modal-body">

                                <div class="row clearfix">
                                    <div class="col-md-12">
                                        <span>{{data.unit_kerja_uraian}}</span> <br>
                                    </div>
                                </div>
                                <hr>


                                  <div class="row clearfix">
                                      <div class="col-md-4 form-control-label">
                                          <label for="kode">Nilai</label>
                                      </div>
                                      <div class="col-md-8">
                                          <div class="form-group">
                                              <div class="form-line">
                                                  <input type="text" v-model="data.nilai" id="nama_urusan" class="form-control">
                                              </div>
                                          </div>
                                      </div>
                                  </div>
                                 
                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                                </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/sakip_evaluasi_kinerja/';
    export default {
        name: "planning_urusan",
        data() {
            return {
                data:{
                    evaluasi_kinerja_id: "",
                    kategori: "",
                    nilai: "",
                    unit_kerja: "",
                    tahun: "2019",
                    unit_kerja_uraian : '',


                },
                kode_urusan: '',
                nama_urusan: '',
                urusan_pemerintahan_id: '',
                list_data: [],
                page_first : 1,
                page_last : 0,
                cari_value : ''
            };
        },

        mounted() {
            this.getData();
            // localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data)
                  this.list_data = res_data
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },

            selectData : function(data){
                
                    this.data.evaluasi_kinerja_id = data.evaluasi_kinerja_id;
                    this.data.kategori= data.kategori;
                    this.data.nilai= data.nilai;
                    this.data.unit_kerja= data.unit_kerja;
                    this.data.unit_kerja_uraian = data.unit_kerja_uraian;
                
            },

            emptyData : function(){
                this.data = {
                   evaluasi_kinerja_id: "",
                    kategori: "",
                    nilai: "",
                    unit_kerja: "",
                    tahun: "",
                    unit_kerja_uraian : '',
                };

            },

            //PAGINASI

            checkKategori(data){

                // <span style="color:blue"><b>A</b></span>
                // <span style="color:green"><b>A</b></span>
                // <span style="color:#e6e600"><b>A</b></span>
                // <span style="color:orange"><b>A</b></span>
                // <span style="color:red"><b>A</b></span>


                if (data > 90) {
                    return `<span style="color:#0066ff"><b>AA</b></span>`
                }
                else if (data >80 && data >=90){
                    return `<span style="color:#33ccff"><b>A</b></span>`
                }
                else if (data >70 && data >=80){
                    return `<span style="color:#00cc66"><b>BB</b></span>`
                }
                else if (data >60 && data >=70){
                    return `<span style="color:#99ff33"><b>B</b></span>`
                }
                else if (data >50 && data >=60){
                    return `<span style="color:#e6e600"><b>CC</b></span>`
                }
                else if (data >30 && data >=50){
                    return `<span style="color:#ff6600"><b>C</b></span>`
                }
                else if (data >0 && data >=30){
                    return `<span style="color:#ff0000"><b>D</b></span>`
                } else{
                    return `<span class="glyphicon glyphicon-remove" aria-hidden="true"></span>`
                }
            },

            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            Printing : function(){
                // printMe
                // var elem = document.getElementById("printMe");
                // var domClone = elem.cloneNode(true);

                // var $printSection = document.getElementById("printSection");

                // if (!$printSection) {
                //     var $printSection = document.createElement("div");
                //     $printSection.id = "printSection";
                //     document.body.appendChild($printSection);
                // }

                // $printSection.innerHTML = "";
                // $printSection.appendChild(domClone);
                // window.print();

                this.$htmlToPaper('printMe');

            },

            btn_prev : function(){
              if(this.page_first>1){
                this.page_first--
              }else{
                this.page_first = 1;
              }
              this.getData();
            },

            btn_next : function(){
              if(this.page_first >= this.page_last){
                this.page_first == this.page_last
              }else{
                this.page_first++;
              }
              this.getData();
            },

            cari_data : function(){
              this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
